"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var of_1 = require("rxjs/observable/of");
var Observable_1 = require("rxjs/Observable");
var zip_1 = require("rxjs/observable/zip");
var party_picker_provider_service_1 = require("../../../shared/services/api/party-picker-provider.service");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var meta_knowledge_provider_service_1 = require("../../../shared/services/api/meta-knowledge-provider.service");
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var from_1 = require("rxjs/observable/from");
var root_category_provider_service_1 = require("../../../shared/services/api/root-category-provider.service");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var PartyPickerSettingsComponent = /** @class */ (function (_super) {
    __extends(PartyPickerSettingsComponent, _super);
    function PartyPickerSettingsComponent(communicationService, rootCategoryProviderService, partyPickerProviderService, kbService, metaKnowledgeProviderService, classifierService, actionService, processService, stateService) {
        var _this = _super.call(this, communicationService) || this;
        _this.communicationService = communicationService;
        _this.rootCategoryProviderService = rootCategoryProviderService;
        _this.partyPickerProviderService = partyPickerProviderService;
        _this.kbService = kbService;
        _this.metaKnowledgeProviderService = metaKnowledgeProviderService;
        _this.classifierService = classifierService;
        _this.actionService = actionService;
        _this.processService = processService;
        _this.stateService = stateService;
        _this.FormType = idm_dynamic_layout_interpreter_1.FormType;
        _this.isReady = false;
        _this.isInWrongForm = false;
        _this._destroy$ = new Subject_1.Subject();
        return _this;
    }
    Object.defineProperty(PartyPickerSettingsComponent.prototype, "state", {
        set: function (state) {
            this._state = state;
        },
        enumerable: true,
        configurable: true
    });
    PartyPickerSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.initState();
        this.rootCategoryProviderService.getRootCategoryId(this.category).pipe(operators_1.switchMap(function (rootCategoryId) {
            if (rootCategoryId) {
                return _this.metaKnowledgeProviderService.getPartyDefinitions(rootCategoryId).pipe(operators_1.switchMap(function (partyDefinitions) {
                    _this.partyDefinitions = partyDefinitions;
                    var metaFields$ = _this.getSubEntitiesWithPartyLookup(_this.category, partyDefinitions);
                    var filterSettings$ = _this.partyPickerProviderService.getPartyFilterFunctions(rootCategoryId);
                    var partyRoles$ = _this.classifierService.loadAllClassifiers(partyDefinitions.roleCategory);
                    var partyTypes$ = _this.classifierService.loadAllClassifiers(partyDefinitions.type.category);
                    var partyStates$ = from_1.from(_this.processService.getProcessesWithTrackInfo()).pipe(operators_1.switchMap(function (processes) {
                        var targetEntityProcess = processes.find(function (process) {
                            return process.getCategorySystemName() === partyDefinitions.category;
                        });
                        if (targetEntityProcess) {
                            return from_1.from(_this.stateService.getStates(targetEntityProcess.getId()));
                        }
                        else {
                            return of_1.of(null);
                        }
                    }));
                    return zip_1.zip(metaFields$, filterSettings$, partyRoles$, partyTypes$, partyStates$);
                }), operators_1.map(function (_a) {
                    var metaFields = _a[0], filterSettings = _a[1], partyRoles = _a[2], partyTypes = _a[3], partyStates = _a[4];
                    _this.availableSubEntityFields = metaFields;
                    if (_this.selectedSubEntityField) {
                        _this.selectedSubEntityField = _this.availableSubEntityFields.find(function (metaField) {
                            return metaField.getSystemName() === _this.selectedSubEntityField['metaFieldId']['systemName'];
                        });
                    }
                    _this.filterSettings = filterSettings;
                    if (_this._filterConfigs && _this._filterConfigs.length) {
                        _this._filterConfigs.forEach(function (config) {
                            var filter = filterSettings.find(function (filterSetting) { return filterSetting.key === config.key; });
                            if (filter) {
                                filter.config = config;
                                filter.enabled = true;
                            }
                        });
                    }
                    _this.partyRoles = partyRoles.getData();
                    _this.partyTypes = partyTypes.getData();
                    _this.partyStates = partyStates;
                    return true;
                }));
            }
            return Observable_1.Observable.of(null);
        }), operators_1.takeUntil(this._destroy$))
            .subscribe(function (result) {
            if (result) {
                _this.isReady = true;
            }
            else {
                _this.isInWrongForm = true;
            }
        });
    };
    PartyPickerSettingsComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    PartyPickerSettingsComponent.prototype.onDisplayModeChange = function ($event) {
        this.isMultiSelect = $event.value;
        this.changeCommunicationSettings();
    };
    PartyPickerSettingsComponent.prototype.changeCommunicationSettings = function () {
        var data = {
            bindings: {},
            state: this.getState(),
            fields: {}
        };
        if (this.selectedSubEntityField) {
            data.fields['field'] = this.selectedSubEntityField;
        }
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, data));
    };
    PartyPickerSettingsComponent.prototype.getState = function () {
        return {
            subEntityField: this.selectedSubEntityField,
            filterConfigs: this.getFilterConfigs(),
            isMultiSelect: this.isMultiSelect,
            subEntityPartyField: this._subEntityPartyField,
            subEntityRoleField: this._subEntityRoleField,
            configured: this.isConfiguredCorrectly(),
            tooltipSettings: this._tooltipSettings
                ? this._tooltipSettings.toJsonString()
                : undefined,
        };
    };
    PartyPickerSettingsComponent.prototype.setSelectedSubEntityField = function (metaField) {
        var _this = this;
        this.selectedSubEntityField = metaField;
        this._subEntityPartyField = null;
        this._subEntityRoleField = null;
        if (metaField) {
            this.kbService.getMetaFields(metaField.getCompoundCategorySystemName())
                .takeUntil(this._destroy$)
                .take(1)
                .subscribe(function (subEntityMetaFields) {
                subEntityMetaFields.forEach(function (subEntityMetaField) {
                    switch (subEntityMetaField.getCompoundCategorySystemName()) {
                        case _this.partyDefinitions.category:
                            _this._subEntityPartyField = subEntityMetaField.getSystemName();
                            break;
                        case _this.partyDefinitions.roleCategory:
                            _this._subEntityRoleField = subEntityMetaField.getSystemName();
                    }
                });
                _this.changeCommunicationSettings();
            });
        }
    };
    PartyPickerSettingsComponent.prototype.initState = function () {
        this.selectedSubEntityField = this._state['subEntityField'];
        this._filterConfigs = this._state['filterConfigs'];
        this.isMultiSelect = !!(this._state['isMultiSelect'] || this._state['isMultiSelect'] === '');
        this._subEntityPartyField = this._state['subEntityPartyField'];
        this._subEntityRoleField = this._state['subEntityRoleField'];
        if (this._state['tooltipSettings']) {
            this._tooltipSettings = idm_ng_controls_1.TooltipSettings.fromJsonString(this._state['tooltipSettings']);
        }
    };
    PartyPickerSettingsComponent.prototype.getFilterConfigs = function () {
        var filterConfigs = [];
        this.filterSettings.forEach(function (filter) {
            if (filter.enabled) {
                filterConfigs.push(filter.config);
            }
        });
        return filterConfigs;
    };
    PartyPickerSettingsComponent.prototype.getSubEntitiesWithPartyLookup = function (category, partyDefinitions) {
        var _this = this;
        return this.kbService.getMetaFields(category).pipe(operators_1.switchMap(function (metaFields) {
            var subEntityMetaFields = metaFields.filter(function (metaField) { return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY; });
            var observables$ = subEntityMetaFields
                .map(function (metaField) { return _this.kbService.getMetaFields(metaField.getCompoundCategorySystemName())
                .map(function (innerSubEntityMetaFields) { return ({
                metaField: metaField,
                withPartyFields: innerSubEntityMetaFields.some(function (innerMetaField) {
                    return innerMetaField.getCompoundCategorySystemName() === partyDefinitions.category;
                })
            }); }); });
            return zip_1.zip.apply(void 0, observables$);
        }), operators_1.map(function (result) {
            var metaFieldsWithPartyLookup = [];
            result.forEach(function (subEntity) { return subEntity.withPartyFields && metaFieldsWithPartyLookup.push(subEntity.metaField); });
            return metaFieldsWithPartyLookup;
        }));
    };
    PartyPickerSettingsComponent.prototype.isConfiguredCorrectly = function () {
        return !!this.selectedSubEntityField && (this.formType === idm_dynamic_layout_interpreter_1.FormType.VIEW || !!(this.getFilterConfigs().length));
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PartyPickerSettingsComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], PartyPickerSettingsComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], PartyPickerSettingsComponent.prototype, "controlLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], PartyPickerSettingsComponent.prototype, "formType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], PartyPickerSettingsComponent.prototype, "languages", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], PartyPickerSettingsComponent.prototype, "state", null);
    PartyPickerSettingsComponent = __decorate([
        core_1.Component({
            
            selector: 'ejustice-party-picker-settings',
            template: require('./party-picker-settings.component.html'),
            styles: [require('./party-picker-settings.component.css')],
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "<ejustice-party-picker-settings\n                    [category]=\"category\"\n                    [state]=\"%{state}\"\n                    [languages]=\"%{languages}\"\n                    [controlLabel]=\"%{controlLabel}\"\n                    [formType]=\"%{formType}\"\n                    [currentLanguageId]=\"%{currentLanguageId}\">\n              </ejustice-party-picker-settings>"
        }),
        __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService,
            root_category_provider_service_1.RootCategoryProviderService,
            party_picker_provider_service_1.PartyPickerProviderService,
            idm_kb_service_client_js_1.KbService,
            meta_knowledge_provider_service_1.MetaKnowledgeProviderService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_workflow_service_client_js_1.ActionService, idm_workflow_service_client_js_1.ProcessService, idm_workflow_service_client_js_1.StateService])
    ], PartyPickerSettingsComponent);
    return PartyPickerSettingsComponent;
}(idm_ng_controls_1.BaseSettings));
exports.PartyPickerSettingsComponent = PartyPickerSettingsComponent;
//# sourceMappingURL=party-picker-settings.component.js.map